import { Ref, ref } from "vue";
import { defineStore } from "pinia";
import { getMsgShield, getServerConfig } from "@/api/php/serverConfig"
import { ServerModel } from "@/model/serverModel";
import Platform from "@/config/platform";
import EventBus from "@/uitls/EventBus";
import { initPlayerDomain } from "@/store/playerDomain.ts";

export const serverConfigPiniaState = defineStore("serverConfig", () => {
    //是否关闭聊天
    const offChat = ref(true);
    //是否关闭球圈评论
    const offComments = ref(true);
    //是否关闭积分商城
    const offStore = ref(true);
    //首页今日热门的title
    const topTtitle = ref("");
    //首页底下的备案信息
    const h5Foot = ref("");
    //是否有数据了
    const isData = ref(false);

    //首页弹出来的广告
    // const alertRedImg = ref("")
    const alertToActivityId = ref('')

    //清原直播间轮播图的文字
    const configNoticebarText = ref("")
    //备用域名，在直播间聊天有用到
    const com = ref("");

    const msgShield = ref([]);

    //用户第一次进入直播间，弹出红包
    const playHbTime = ref(100)
    const playHbPrice = ref('18')
    const playHbUrl = ref('')
    const playHbWeclome = ref('')

    //评论区的广告图片
    const commentAdImg = ref('')
    const commentAdUrl = ref('')
    //赛程广告
    const matchAD = ref(null)

    //开启赛况分析
    const is_has_intelligence = ref(false)
    //开启指数
    const is_has_history = ref(false)

    //开启显示主播
    const is_show_host = ref(false)

    //直播间是否显示下载条
    const is_show_up68_copy_share = ref(false)

    //午夜场地址
    const night_url = ref("")

    //直播间屏蔽关键词
    const roomMsgShield = async () => {
        const res: any = await getMsgShield();
        // console.log("关键词",res);
        msgShield.value = res.data;

    }
    //客服uid
    const service_uid = ref('')
    //客服uid
    const service_uid_night = ref('')

    const configCopyid = ref('')
    const configNoticebarTextTo = ref('')

    const home_red_url_type = ref()
    const home_red_url = ref()

    const chat_ad_interval = ref()

    const openAd = ref({ img: '', time: 0, url: '', enabled: false })

    const live_load_img = ref('');

    const is_lb = ref(false);

    const live_jump_time = ref(0);
    const live_jump_closable = ref(1);

    const live_jump_interval = ref(0);
    const live_jump_info = ref('');
    const live_jump_url = ref('');

    const is_home_down_tab = ref(false);
    const forever_url = ref([]);

    const web_fullscreen_tips = ref(false);
    const web_pm_tips = ref(false);

    const replay_download_tips = ref(0);
    const home_lefttop_white_gif = ref('');
    const home_lefttop_black_gif = ref('');
    const is_has_player_stats = ref(false);
    const is_has_tencent_captcha = ref(false);
    let configRequestPromise: Promise<void> | null = null;

    const getConfig = async (dovalue = true) => {

        if (dovalue && isData.value) {
            return;
        }

        // App 和播放器页可能同时初始化配置，复用请求避免重复拉配置和重复检测播放器域名。
        if (dovalue && configRequestPromise) {
            return configRequestPromise;
        }

        // console.log('来请求配置文件成功====》');

        const request = (async () => {
        const res: any = await getServerConfig()
        if (res.code == 200) {
            const data = res.data as ServerModel;
            console.log('配置文件data', data);
            //获取播放器域名
            const domain = initPlayerDomain(data.h5_play_url_list);
            console.log('当前使用的播放器域名:', domain);

            localStorage.setItem('log_api_url', data.log_api_url)
            Platform.h5_play_url = domain;
            offChat.value = data.all_chat == "2" ? true : false;
            offComments.value = data.ball_news_comment == "2" ? true : false;
            offStore.value = data.shop_open_status == "2" ? true : false;
            Platform.down68 = data.app_68;
            Platform.chartSendTime = data.chat_interval_time;
            Platform.chatCharactersNum = Number(data.chat_characters_num) || 100;
            configNoticebarText.value = data.pmd_content;
            com.value = data.chat_show_url;
            topTtitle.value = data.top_title;
            h5Foot.value = data.h5_foot_str;
            isData.value = true;

            home_red_url_type.value = data.home_red_url_type;
            home_red_url.value = data.home_red_url;
            chat_ad_interval.value = data.chat_ad_interval;
            localStorage.setItem('chat_ad_interval', data.chat_ad_interval)
            localStorage.setItem('bgurlData', data.live_load_img)
            EventBus.emit("bgurlData", data.live_load_img);
            live_load_img.value = data.live_load_img;

            // alertRedImg.value = data.home_red_img;
            playHbPrice.value = data.chat_hb_price;
            playHbTime.value = parseInt(data.chat_hb_time);
            playHbUrl.value = data.chat_hb_url;
            playHbWeclome.value = data.red_envelope_weclome;

            alertToActivityId.value = data.home_red_url
            commentAdImg.value = data.new_ac_ad_img;
            commentAdUrl.value = data.new_ac_ad_url;
            night_url.value = data.night_url;
            service_uid_night.value = data.service_uid_night;
            if (data.home_red_img !== '') {
                EventBus.emit("alertRedImg", data.home_red_img);
            }
            configCopyid.value = data.host_id_copy
            configNoticebarTextTo.value = data.pmd_url
            service_uid.value = data.service_uid
            if (configNoticebarText.value !== '') {
                EventBus.emit("configNoticebarText");
            }
            // encryptionServerConfig 新增字段is_show_host  1显示主播，2隐藏主播

            if (data.match_ad_img != '') {
                matchAD.value = {
                    img: data.match_ad_img,
                    url: data.match_ad_url
                }
            }
            if (data.is_has_intelligence == "1") {
                is_has_intelligence.value = true;
            }
            if (data.is_has_history == "1") {
                is_has_history.value = true
            }
            if (data.is_show_up68_copy_share == "1") {
                is_show_up68_copy_share.value = true
            }

            if (data.is_show_host == "1") {
                is_show_host.value = true
            }

            // if (data.openad_img && data.openad_img != '' && data.openad_time != '') {
            openAd.value = {
                img: data.openad_img, time: Number(data.openad_time), url: data.openad_url,
                enabled: data.openad_img && data.openad_img != '' && data.openad_time != '',
            };
            EventBus.emit("openAd", openAd.value);

            is_lb.value = data.is_lb == "2";

            live_jump_time.value = Number(data.live_jump_time);
            live_jump_closable.value = Number(data.live_jump_closable);
            live_jump_interval.value = Number(data.live_jump_interval);
            if (data.live_jump_info && data.live_jump_info != '') {
                let info = "<p>" + data.live_jump_info + "</p>";
                info = info.replace(/\n/g, '<br>')
                live_jump_info.value = info;
            }
            live_jump_url.value = data.live_jump_url;

            is_home_down_tab.value = data.is_home_down_tab == "1";

            forever_url.value = data.forever_url;
            web_fullscreen_tips.value = data.web_fullscreen_tips === "1";
            web_pm_tips.value = data.web_pm_tips === "1";

            Platform.downUrlIos = data.download_url_ios;
            Platform.downUrlAndroid = data.download_url_android;
            Platform.downUrlWebclip = data.download_url_webclip;
            Platform.downMobileprovision = data.download_mobileprovision;
            
            Platform.serverId = Number(data.service_uid);

            if(data.replay_download_tips){
                replay_download_tips.value = Number(data.replay_download_tips);
            }
            home_lefttop_white_gif.value = data.home_lefttop_white_gif;
            home_lefttop_black_gif.value = data.home_lefttop_black_gif;

            is_has_player_stats.value = data.is_has_player_stats == 1;
            is_has_tencent_captcha.value = data.is_has_tencent_captcha == 1;

            EventBus.emit("getServerConfig");
            // }
        }
        })();

        if (!dovalue) {
            return request;
        }

        configRequestPromise = request;
        try {
            return await request;
        } finally {
            if (configRequestPromise === request) {
                configRequestPromise = null;
            }
        }
    }

    return {
        isData,
        home_red_url_type,
        home_red_url,
        chat_ad_interval,
        offChat,
        service_uid_night,
        is_show_host,
        night_url,
        getConfig,
        service_uid,
        configNoticebarText,
        configCopyid,
        configNoticebarTextTo,
        com,
        offComments,
        is_has_intelligence,
        is_has_history,
        offStore,
        topTtitle,
        h5Foot,
        roomMsgShield,
        msgShield,
        playHbTime,
        playHbPrice,
        playHbWeclome,
        playHbUrl,
        alertToActivityId,
        commentAdImg,
        commentAdUrl,
        matchAD,
        openAd,
        live_load_img,
        is_show_up68_copy_share,
        is_lb,
        live_jump_time,
        live_jump_closable,
        live_jump_interval,
        live_jump_info,
        live_jump_url,
        is_home_down_tab,
        forever_url,
        web_fullscreen_tips,
        web_pm_tips,
        replay_download_tips,
        home_lefttop_white_gif,
        home_lefttop_black_gif,
        is_has_player_stats,
        is_has_tencent_captcha,
    };
});
